import { Icon } from '@dx-ui/osc-icon';

const FormErrorIcon = () => (
  <Icon name="close-circle" size="sm" variant="solid" className="text-surface-error" />
);

export { FormErrorIcon };
export default FormErrorIcon;
